import {
    VIEW_CEREBRUMX_INTEGRATION_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_RESULT,
    VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL,
    VIEW_CEREBRUMX_INTEGRATION_CLOSE_MODAL,
    VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_RESULT,
    VIEW_CEREBRUMX_INTEGRATION_SET_INTEGRATIONS,
    VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_RESULT,
} from 'Redux/actionTypes';

export const viewCerebrumXRequest = (companyIntegrationId) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_REQUEST,
    payload: { companyIntegrationId }
})

export const viewCerebrumXResult = (result) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_RESULT,
    payload: result
})

export const viewCerebrumXOpenModal = (data) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL,
    payload: data
})

export const viewCerebrumXCloseModal = () => ({
    type: VIEW_CEREBRUMX_INTEGRATION_CLOSE_MODAL
})

export const viewCerebrumXGetIntegrationRequest = (companyIntegrationId) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_REQUEST,
    payload: { companyIntegrationId }
})

export const viewCerebrumXGetIntegrationResult = (result) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_RESULT,
    payload: result
})

export const viewCerebrumXSetDevice = (device) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_SET_INTEGRATIONS,
    payload: device
})

export const viewCerebrumXSaveProfileRequest = (data) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST,
    payload: data
})

export const viewCerebrumXSaveProfileResult = (result) => ({
    type: VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_RESULT,
    payload: result
})